import picture1 from "./picture/二维码白.jpg";

function EndPage () {

    return(
        <>
            <div id="phone" style={{backgroundColor:"RoyalBlue"}}>
                <div style={{marginLeft:"7.5%",marginBottom:"-2.6%", display:"flex", flexDirection:"row"}}>
                    <div style={{display:"flex", flexDirection:"column", margin:" 7% 5%"}}>
                        <b style={{ fontSize:window.innerWidth*0.021, color:"white", fontFamily:"SimSun", marginLeft:"0.5%", fontWeight:"bolder"}}>中科心感（南京）医疗电子科技有限公司</b>
                        <p style={{ fontSize:window.innerWidth*0.0158, color:"white", fontFamily:"SimSun", marginLeft:"0.5%", fontWeight:"bold", marginTop:"1%"}}>Zhongke Xingan (Nanjing) Medical Electronic Technology Co., Ltd</p>
                        <p style={{ fontSize:window.innerWidth*0.0158, color:"white", fontFamily:"SimSun", marginLeft:"0.5%", fontWeight:"bold", marginTop:"0.26%"}}>地址:南京市浦口区江浦街道浦滨路320号科创总部大厦C座15F</p>
                        <p style={{ fontSize:window.innerWidth*0.0158, color:"white", fontFamily:"SimSun", marginLeft:"0.5%", fontWeight:"bold", marginTop:"0.26%"}}>联系我们: +025-5816 2151</p>
                        <p style={{ fontSize:window.innerWidth*0.013, color:"white", fontFamily:"SimSun", marginLeft:"0.5%", fontWeight:"bold", marginTop:"0.26%"}}>（赵先生: 13051809155/李小姐: 13718254409）</p>
                        <p style={{color:"white",fontSize:window.innerWidth*0.0079, margin:"-0.8% -0.3% -0.79% 96.3%", fontWeight:"bolder"}}> &gt; &gt;</p>
                        <hr style={{width:window.innerWidth*0.47, height:"1px", backgroundColor:"white", marginTop:"1%", marginLeft:"0.5%"}}/>
                    </div>
                    <div style={{margin:"5% 0.5% 9.3% 5.3%", width:window.innerWidth*0.111, display:"flex", flexDirection:"column"}}>
                        <img style={{height:window.innerWidth*0.191, width:window.innerWidth*0.191, marginLeft:"1.58%", marginBottom:"1.3%"}} src={picture1} alt=""/>
                        <p style={{ fontSize:window.innerWidth*0.0168, color:"white", fontFamily:"SimSun", marginLeft:"1.5%", fontWeight:"bold", marginTop:"0.26%", marginRight:"-70%"}}>服务咨询请扫码官方微信公众号</p>
                    </div>

                </div>
                <div style={{textAlign:"center", display:"flex", flexDirection:"row", fontSize:window.innerWidth*0.02,marginLeft:window.innerWidth*0.08}}>
                  <p>Copyright © 2021-2026 心感健康  sengain.cn All Rights Reserved.</p>
                  <p>备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备2020057505号-2</a></p>
                </div>
            </div>
        </>
    )
}

export default EndPage
